// "Been there, done that" check-state persistence. localStorage-only
// for v1 — anon users get the same experience as authed users, and we
// don't yet need cross-device sync. If we ever want sync, add a small
// `checklist` table keyed by user_id + item_id and mirror the read/
// write helpers below to TanStack mutations.
//
// Storage shape: a single key holding a JSON array of checked item ids.
// Compact, easy to back up, easy to migrate later.

const KEY = "myams.beenThere.checked";

function load(): Set<string> {
  if (typeof localStorage === "undefined") return new Set();
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return new Set();
    return new Set(arr.filter((x): x is string => typeof x === "string"));
  } catch { return new Set(); }
}

function save(set: Set<string>): void {
  if (typeof localStorage === "undefined") return;
  try { localStorage.setItem(KEY, JSON.stringify([...set])); } catch { /* ignore */ }
}

export function getChecked(): Set<string> {
  return load();
}

export function isChecked(id: string): boolean {
  return load().has(id);
}

export function toggleChecked(id: string): boolean {
  const set = load();
  if (set.has(id)) { set.delete(id); save(set); return false; }
  set.add(id); save(set); return true;
}

export function resetChecked(): void {
  save(new Set());
}
